import type { Lead } from "@/mocks/leadsData";

type Props = {
  lead: Lead;
  onReassign?: () => void;
};

export function AssignedTeamCard({ lead, onReassign }: Props) {
  const initials = lead.assigned
    ? lead.assigned
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
    : "U";

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 md:p-6">
      <h3 className="text-sm font-semibold text-gray-900 mb-4">Assigned To</h3>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-sm font-bold text-indigo-700 flex-shrink-0">
          {initials}
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-gray-900">{lead.assigned || "Unassigned"}</p>
          <p className="text-xs text-gray-500">Primary Owner</p>
        </div>
        {onReassign && (
          <button
            onClick={onReassign}
            className="text-xs font-medium text-indigo-600 hover:text-indigo-700 whitespace-nowrap transition-colors cursor-pointer"
          >
            Reassign
          </button>
        )}
      </div>
    </div>
  );
}